export const HDI_GENERATED_PRESIGNED_URLS = 'HDI_GENERATED_PRESIGNED_URLS';
export const HDI_ATTACHMENTS_SAVED = 'HDI_ATTACHMENTS_SAVED';
export const HDI_ATTACHMENTS_SAVED_ERROR = 'HDI_ATTACHMENTS_SAVED_ERROR';
export const HDI_ATTACHMENTS_DOWNLOAD = 'HDI_TICKET_ATTACHMENTS_DOWNLOAD';
export const HDI_ATTACHMENTS_DOWNLOAD_ERROR = 'HDI_TICKET_ATTACHMENTS_DOWNLOAD_ERROR';
